var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChechActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.066 11.13a1.23 1.23 0 0 0-1.712 0 1.17 1.17 0 0 0 0 1.677l3.902 3.824a.5.5 0 0 0 .725-.027l6.665-7.58a1.17 1.17 0 0 0 0-1.677 1.23 1.23 0 0 0-1.712 0l-5.301 6.029z"
})));
export default SvgIcChechActive;